import { type CarrierContactFragment, CarrierContactType } from "@qw/graphql";
import { Group } from "@qw/ui";

import { CarrierContactCard } from "./carrier-contact-card";
import { CreateCarrierContactButton } from "./carrier-contact-modal";

interface Props {
  type: CarrierContactType;
  contacts: CarrierContactFragment[];
  appetiteProductId: string;
  canEdit: boolean;
}

export const CarrierContactList: React.FC<Props> = ({ type, contacts, appetiteProductId, canEdit }) => {
  const showEmptyState = contacts.length === 0;

  const label =
    type === CarrierContactType.Submission ? "Submission Contacts (Inboxes & Underwriters)" : "Reference Contacts";

  return (
    <Group className="gap-0">
      <div className="flex justify-between items-center">
        <h5 className="text-xs font-semibold text-muted-foreground">{label}</h5>
        {canEdit && (
          <CreateCarrierContactButton type={type} contacts={contacts} appetiteProductId={appetiteProductId} />
        )}
      </div>

      {!showEmptyState && (
        <Group className="mt-2 border rounded-md gap-0">
          {contacts.map((contact) => (
            <CarrierContactCard
              key={contact.id}
              type={type}
              contact={contact}
              appetiteProductId={appetiteProductId}
              canEdit={canEdit}
            />
          ))}
        </Group>
      )}
      {showEmptyState && <div className="text-muted-foreground text-sm">No contacts</div>}
    </Group>
  );
};
